<!-- Button Crea Azione-->
<div class="ui-g-12 text-center">
  <button pButton class="k-generic-btn" type="button" (click)="createCampaignAction()"
    label="{{ 'campaign.addAction' | translate }}">
  </button>
  <!-- Button Duplica azione Azione-->
  <button pButton class="k-generic-btn" type="button" (click)="openPopUpDuplicateActions()"
    label="{{ 'campaign.duplicateAction' | translate }}">
  </button>
  <!-- Button Verifica Generazione Coupon -->
  <button *ngIf="campaignAction && campaignAction.length > 0" pButton class="k-generic-btn" type="button"
    (click)="refreshCampaignActionList()" label="{{ 'campaign.checkGenerationCoupon' | translate }}">
  </button>
</div>

<!-- Template Action presenti per la campagna -->
<div class="ui-g-12" *ngFor="let action of campaignAction; let i = index">
  <p-panel header="#{{action.message_instance_id}} {{action.name}}">
    <!-- Descrizione Azione-->
    <div class="ui-g ui-fluid ui-g-nopad" style="margin-bottom: 10px;">
      <div class="ui-g-12 ui-md-8 ui-g-nopad">
        <span>{{action.action_type_name}} </span>
      </div>
      <div class="ui-g-12 ui-md-4 text-right ui-g-nopad">
        <!-- Bottone elimina Azione -->
        <p-button pTooltip="{{'common.delete' | translate}}" icon="fa fa-trash"
          styleClass="ui-button-info" (click)="deleteAction(action)">
        </p-button>
        <!-- Button Deploy Azione-->
        <p-button *ngIf="action.flg_preview === '0' && action.flg_dpl_message_instance === 'G'"
        pTooltip="{{'common.deployAction' | translate}}" icon="fa fa-check" styleClass="ui-button-info"
          (click)="deployAction(action.message_instance_id)">
        </p-button>
        <!-- Button Visualizza Azione-->
        <p-button *ngIf="action.flg_preview === '0' && (action.coupon_generation_status === 'G' || action.coupon_generation_status === 'P' )"
          pTooltip="{{'campaign.showAction' | translate}}" icon="fa fa-eye" styleClass="ui-button-info"
          (click)="openActionGenerated(action)">
        </p-button>
        <!-- Button Modifica Azione-->
        <p-button
          pTooltip="{{'common.edit' | translate}}" icon="fa fa-pencil"
          styleClass="ui-button-info" (click)="viewAction(action)">
        </p-button>
        <!-- Button Preview Coupons-->
        <p-button *ngIf="action.flg_preview === '1' && action.action_type_code === 'CPN'"
          pTooltip="{{'campaign.generatePreviewCoupons' | translate}}" icon="fa fa-check-square-o"
          styleClass="ui-button-info" (click)="confirmPreview(action)">
        </p-button>
        <!-- Button Preview Messages-->
        <p-button *ngIf="action.flg_preview === '1' && action.action_type_code === 'MSG'"
          pTooltip="{{'campaign.generatePreviewMessages' | translate}}" icon="fa fa-check-square-o"
          styleClass="ui-button-info" (click)="confirmPreview(action)">
        </p-button>
        <!-- Button Pubblica-->
        <p-button *ngIf="
            action.flg_preview === '1' &&
            action.coupon_generation_status !== 'R' &&
            (action.coupon_generation_status !== 'G' || action.flg_preview === '1') &&
            action.campaign_action_status_id === 9" pTooltip="{{'campaign.publish' | translate}}"
          icon="fa fa-ticket" styleClass="ui-button-info" (click)="confirmPublish(action)">
        </p-button>
        <!-- Button Genera Coupon-->
        <p-button *ngIf="
            action.flg_couponing_method !== 'D' &&
            action.flg_preview === '0' &&
            action.coupon_generation_status !== 'R' &&
            ((action.coupon_generation_status !== 'G' && action.coupon_generation_status !== 'P') || action.flg_preview === '1') &&
            action.campaign_action_status_id === 9" pTooltip="{{'campaign.resumePublish' | translate}}"
          icon="fa fa-cogs" styleClass="ui-button-info" (click)="generateCoupon(action)">
        </p-button>
        <!-- Button Visualizza Coupon -->
        <p-button
          *ngIf="(action.message_instance_id && (action.coupon_generation_status === 'G' || action.coupon_generation_status === 'P') && action.actual_generated_coupon > 0) && action.action_type_code === 'CPN'"
          pTooltip="{{'campaign.showCoupon' | translate}}" icon="fa fa-table" styleClass="ui-button-info"
          (click)="showCoupon(action)">
        </p-button>
        <!-- Button Visualizza Messaggio -->
        <p-button
          *ngIf="(action.message_instance_id && (action.coupon_generation_status === 'G' || action.coupon_generation_status === 'P') && action.actual_generated_coupon > 0) && action.action_type_code === 'MSG'"
          pTooltip="{{'campaign.showMessage' | translate}}" icon="fa fa-table" styleClass="ui-button-info"
          (click)="showCoupon(action)">
        </p-button>
      </div>
    </div>
    <!-- Date Emissione -->
    <div class="ui-g ui-fluid ui-g-nopad" style="margin-bottom: 10px;">
      <div class="ui-g-12 ui-md-8 ui-g-nopad">
        <strong>{{'common.date_start' | translate}}: </strong>
        <span>{{action.start_date | date: calendarTranslateService.pcalendarTranslate.dateFormatFilter}} </span>
        <strong>{{'common.date_end' | translate}}: </strong>
        <span>{{action.end_date | date: calendarTranslateService.pcalendarTranslate.dateFormatFilter}} </span>
      </div>
      <!-- Quantità Coupon Generati -->
      <div class="ui-g-12 ui-md-4 text-right ui-g-nopad"
        *ngIf="action.campaign_action_status_id === 9 && (action.coupon_generation_status === 'P' || action.coupon_generation_status === 'R' || action.coupon_generation_status === 'G' || action.coupon_generation_status === 'E' || (action.flg_dpl_message_instance === '0' && action.flg_couponing_method === 'D'))">
        <strong>{{'campaign.generatedCoupon' | translate}}:
        </strong>{{action.actual_generated_coupon || 0}}
      </div>
    </div>

    <!-- Stato Azione-->
    <div class="ui-g ui-fluid ui-g-nopad">
      <div class="ui-g-12 ui-md-8 ui-g-nopad">
        <span *ngIf="action.campaign_action_status_id === 0">
          <i class="fa fa-circle" style="color: #d00;"></i>
          <strong>{{'campaign.configureAction' | translate}}</strong>
        </span>
        <span *ngIf="action.campaign_action_status_id === 3">
          <i class="fa fa-circle" style="color: #f84519;"></i>
          <strong>{{'campaign.dateEmissionConfigured' | translate}}</strong>
        </span>
        <span *ngIf="action.campaign_action_status_id === 4">
          <i class="fa fa-circle" style="color: #ff7623;"></i>
          <strong>{{'campaign.configuredEmission' | translate}}</strong>
        </span>
        <span *ngIf="action.campaign_action_status_id === 5">
          <i class="fa fa-circle" style="color: #ffbe01;"></i>
          <strong>{{'campaign.configuredParameters' | translate}}</strong>
        </span>
        <span *ngIf="action.campaign_action_status_id === 6">
          <i class="fa fa-circle" style="color: #f3eb00;"></i>
          <strong>{{'campaign.configuredFruition' | translate}}</strong>
        </span>
        <span *ngIf="action.campaign_action_status_id === 9">
          <i class="fa fa-circle" style="color: #35b000;"></i>
          <strong>{{'campaign.actionConfigured' | translate}}</strong>
          <span *ngIf="action.flg_preview === '1'">[Preview]</span>
          <span *ngIf="action.flg_preview === '0'">[{{'campaign.published' | translate}}]</span>
        </span>
      </div>

      <!-- Stato Pubblicazione-->
      <div class="ui-g-12 ui-md-4 text-right ui-g-nopad" *ngIf="action.flg_preview === '0'">
        <span *ngIf="action.coupon_generation_status === 'R'">
          <strong>{{'campaign.publishInProgress' | translate}}</strong>
        </span>
        <span *ngIf="(action.coupon_generation_status === 'P' || action.coupon_generation_status === 'G')">
          <strong>{{'campaign.publishDone' | translate}}</strong>
        </span>
        <span *ngIf="action.coupon_generation_status === 'E'">
          <strong>{{'campaign.publishError' | translate}}</strong>
        </span>
        <span *ngIf="action.flg_dpl_message_instance === '0' && action.flg_couponing_method === 'D'">
          <strong>{{'campaign.publishDone' | translate}}</strong>
        </span>
      </div>

      <!-- Stato Preview-->
      <div class="ui-g-12 ui-md-4 text-right ui-g-nopad" *ngIf="action.flg_preview === '1'">
        <span *ngIf="action.flg_dpl === 'R'">
          <strong>{{'campaign.previewInProgress' | translate}}</strong>
        </span>
        <span *ngIf="action.flg_dpl === 'G'">
          <strong>{{'campaign.previewDone' | translate}}</strong>
        </span>
        <span *ngIf="action.flg_dpl === 'E'">
          <strong>{{'campaign.previewError' | translate}}</strong>
        </span>
      </div>

    </div>
  </p-panel>

</div>

<!-- Template Action non presenti per la campagna -->
<div *ngIf="!campaignAction" class="margin-bottom">
  <span>{{'campaign.noActionFound' | translate}}</span>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-list2/campaign-action-list/campaign-action-list.component.html